import React from 'react'

import { Spinner } from '@acorns/web-components'

import { StyledSubmitButton } from './styled-components'

interface Props {
  handleCtaPress: () => void
  isLoading?: boolean
  children: React.ReactNode
}

export const SubmitButton = (props: Props) => {
  return (
    <StyledSubmitButton
      onPress={props.handleCtaPress}
      disabled={props.isLoading}
    >
      {props.isLoading ? (
        <Spinner height={20} width={20} white={true} />
      ) : (
        props.children
      )}
    </StyledSubmitButton>
  )
}
